import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.182 5.073c0-1.426 0-2.139.277-2.683a2.546 2.546 0 0 1 1.113-1.113C6.116 1 6.829 1 8.255 1h.534c2.174 0 3.261 0 4.091.423.73.372 1.325.966 1.697 1.697C15 3.95 15 5.037 15 7.21v1.58c0 2.173 0 3.26-.423 4.09a3.882 3.882 0 0 1-1.697 1.697C12.05 15 10.963 15 8.79 15h-.535c-1.426 0-2.139 0-2.683-.277a2.545 2.545 0 0 1-1.113-1.113c-.277-.544-.277-1.257-.277-2.683V5.073Zm6.95 1.742c.646.385.969.578 1.078.828a.851.851 0 0 1 0 .683c-.11.25-.432.442-1.077.828l-1.708 1.02c-.675.403-1.013.605-1.29.578a.852.852 0 0 1-.606-.344c-.165-.225-.165-.618-.165-1.404v-2.04c0-.786 0-1.179.165-1.404a.851.851 0 0 1 .606-.344c.277-.026.615.176 1.29.579l1.708 1.02Zm-8.54-1.971c0-1.568 0-2.353.305-2.951a2.8 2.8 0 0 1 .351-.53A3.882 3.882 0 0 0 1.423 3.12C1 3.95 1 5.037 1 7.21v1.578c0 2.174 0 3.261.423 4.091a3.882 3.882 0 0 0 1.824 1.758 2.796 2.796 0 0 1-.35-.53c-.306-.6-.306-1.383-.306-2.952V4.844Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconSocialVKVideo16 = createIcon(IconComponent);